import pdfMake from "../Reports/pdfmakeWrapper";

const labelCell = (text) => ({
  text,
  bold: true,
  fontSize: 11,
  fillColor: "#f3f4f6",
});

const valueCell = (text) => ({
  text,
  fontSize: 11,
});

export const generateDailyCashReport = (data) => {

  const totalMoneyIn =
    data.moneyIn.startingCash +
    data.moneyIn.collectionAmount +
    data.moneyIn.processingFee;

  const totalMoneyOut =
    data.moneyOut.disbursementAmount +
    data.moneyOut.totalExpenses;

  const cashInHand = totalMoneyIn - totalMoneyOut;

  const reportInfoTable = {
    table: {
      widths: ["25%", "25%", "25%", "25%"],
      body: [
        [
          labelCell("Report Date"),
          valueCell(data.reportDate || "-"),
          labelCell("Cashier / Officer"),
          valueCell("________________"),
        ],
        [
          labelCell("Prepared Time"),
          valueCell("________________"),
          labelCell("Status"),
          valueCell(data.status || "-"),
        ],
      ],
    },

    layout: {
      hLineColor: "#e5e7eb",
      vLineColor: "#e5e7eb",
      paddingLeft: () => 8,
      paddingRight: () => 8,
      paddingTop: () => 8,
      paddingBottom: () => 8,
    },

    margin: [0, 10, 0, 20],
  };

  const expenseBreakdown = {
    table: {
      widths: ["30%", "45%", "25%"],
      body: [
        [
          { text: "Expense Type", bold: true },
          { text: "Remarks", bold: true },
          { text: "Amount", bold: true },
        ],

        ...(data.expenses.length
          ? data.expenses.map((e) => [
              e.type || "-",
              e.remarks || "-",
              e.amount || 0,
            ])
          : [["No Expenses", "-", "0"]]),
      ],
    },

    margin: [0, 5, 0, 10],
  };

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 50, 40, 60],

    content: [
      // HEADER
      {
        text: "DAILY CASH REPORT",
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 5],
      },

      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 5,
            x2: 515,
            y2: 5,
            lineWidth: 1,
          },
        ],
        margin: [0, 0, 0, 15],
      },

      // REPORT INFO
      {
        text: "Report Information",
        fontSize: 13,
        bold: true,
      },
      reportInfoTable,


      // SECTION A
      {
        text: "Section A - Cash In",
        style: "section",
      },
      tableMoney([
        ["Starting Cash", data.moneyIn.startingCash],
        ["Collection Amount", data.moneyIn.collectionAmount],
        ["Processing Fee", data.moneyIn.processingFee],
        ["Total Cash In (A)", totalMoneyIn],
      ]),

      // SECTION B
      {
        text: "Section B - Cash Out",
        style: "section",
        margin: [0, 10, 0, 0],
      },
      tableMoney([
        ["Disbursement / Lent Amount", data.moneyOut.disbursementAmount],
        ["Total Expenses", data.moneyOut.totalExpenses],
        ["Total Cash Out (B)", totalMoneyOut],
      ]),

      // EXPENSES TABLE
      {
        text: "Expense Breakdown",
        style: "section",
        margin: [0, 10, 0, 0],
      },
      expenseBreakdown,

      // SECTION C
      {
        text: "Section C - Closing Cash",
        style: "section",
        margin: [0, 10, 0, 0],
      },
      tableMoney([
        ["Total Cash In (A)", totalMoneyIn],
        ["Total Cash Out (B)", totalMoneyOut],
        ["Cash In Hand (A - B)", cashInHand],
      ]),

      // VERIFICATION
      {
        text:
          "\nPhysical Cash Verification (optional)\n" +
          "Counted Cash In Hand __________________  " +
          "Difference (Counted - System) __________________\n\n" +
          "Verified By __________________  Signature __________________\n\n" +
          "Notes ________________________________________________",
        fontSize: 10,
        margin: [0, 20, 0, 0],
      },
    ],

    styles: {
      section: {
        fontSize: 12,
        bold: true,
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
};

const tableMoney = (rows) => ({
  table: {
    widths: ["70%", "30%"],
    body: rows.map(([label, value]) => [
      { text: label },
      {
        text: value !== undefined ? value.toString() : "-",
        alignment: "right",
      },
    ]),
  },
  margin: [0, 5, 0, 5],
});
